import Hls from 'hls.js/light'
import { createRoot } from 'react-dom/client'
import './index.scss'
import './dayjsinit'
import App from './App'

// react-player will load hls.js from jsdelivr.net unless we preload it like this
window.Hls = Hls

const root = createRoot(document.getElementById('root'))
root.render(
  <App/>
)
